import './dropDown.scss';
import React from 'react';
import { useState, useCallback } from 'react';
import If from '../if';
export interface IProps {
    content?: string | React.ReactElement;
    children: React.ReactElement | null;
}
export interface IState {
    showContainer: boolean;
}
/**
 * 
 * @des 使用 
 * <DropDown content={'title'}>
 *    <Button>
 *      Hover me
 *   </Button>
 * </DropDown>
 */
export const DropDown = (props: IProps) => {
    const { content, children } = props;
    const [showContainer, setShowContainer] = useState(false);
    const handleMouseUserOver = useCallback(() => {
        setShowContainer(true);
    }, [showContainer]);
    const handleMouseOut = useCallback(() => {
        setShowContainer(false);
    }, [showContainer]);
   
    return (
        <div 
        onMouseOver={handleMouseUserOver}
        onMouseLeave={handleMouseOut}
        className="el-dropdown">
            <div className="el-dropdown-target">
                {content}
            </div>
            <If condition={showContainer}>
                <div className="el-dropdown-container">
                    {children}
                </div>
            </If>
        </div>
    )
} 
